import { FadeInUpSmall } from "@/components/Animation";
import { customSanitize } from "@/utils/customSanitize";

type HeadlineV2TagType =
  | "h1-hero"
  | "h1-pages"
  | "h1-posts"
  | "h2"
  | "h3"
  | "h2-small";

type HeadlineV2Props = {
  headline_html_tag: HeadlineV2TagType;
  headline: string;
  overline?: string;
  subline?: string;
  extraClassName?: string;
  isQuote?: boolean;
  disableAnimation?: boolean;
};

export const HeadlineV2 = ({
  headline,
  headline_html_tag,
  overline,
  subline,
  extraClassName = "",
  isQuote = false,
  disableAnimation = false,
}: HeadlineV2Props) => {
  const getHeadline = () => {
    if (!headline) return <></>;

    /* jscpd:ignore-start */
    switch (headline_html_tag) {
      case "h1-hero":
      case "h1-pages":
      case "h1-posts":
        return (
          <h1
            className={`${subline ? "pb-0" : ""} ${headline_html_tag}`}
            dangerouslySetInnerHTML={{ __html: customSanitize(headline) }}
          />
        );
      case "h2":
        return (
          <h2
            className={`${subline ? "pb-0" : ""} ${isQuote ? "quotes-banner-title" : ""}`}
            dangerouslySetInnerHTML={{ __html: customSanitize(headline) }}
          />
        );
      case "h2-small":
        return (
          <h2
            className={`${subline ? "pb-0" : ""} ${isQuote ? "quotes-banner-title" : ""} h2-small`}
            dangerouslySetInnerHTML={{ __html: customSanitize(headline) }}
          />
        );
      case "h3":
        return (
          <h3
            className={`${subline ? "pb-0" : ""} ${isQuote ? "quotes-banner-title" : ""}`}
            dangerouslySetInnerHTML={{ __html: customSanitize(headline) }}
          />
        );
      default:
        return <></>;
    }
  };

  const getOverline = () => {
    if (!overline) return <></>;

    return isQuote ? (
      <blockquote
        className={`overline overline-${headline_html_tag} quotes-banner-subline`}
        dangerouslySetInnerHTML={{ __html: customSanitize(overline) }}
      />
    ) : (
      <p
        className={`overline overline-${headline_html_tag}`}
        dangerouslySetInnerHTML={{ __html: customSanitize(overline) }}
      />
    );
  };

  const getSubline = () => {
    if (!subline) return <></>;

    return isQuote ? (
      <blockquote
        className={`subline subline-${headline_html_tag} quotes-banner-subline`}
        dangerouslySetInnerHTML={{ __html: customSanitize(subline) }}
      />
    ) : (
      <p
        className={`subline subline-${headline_html_tag}`}
        dangerouslySetInnerHTML={{ __html: customSanitize(subline) }}
      />
    );
  };
  /* jscpd:ignore-end */

  const className = `${extraClassName} ${subline ? `${headline_html_tag}` : ""} is-clipped`;

  const content = (
    <>
      {getOverline()}
      {getHeadline()}
      {getSubline()}
    </>
  );

  if (disableAnimation) {
    return <header className={className}>{content}</header>;
  }

  return (
    <header>
      <FadeInUpSmall className={className}>{content}</FadeInUpSmall>
    </header>
  );
};
